import BaseResource from './index'

export default class AgreementResource extends BaseResource {
    static endpoint = '/oasis/restv3/agreements'
    static cacheMaxAge = 60
}
